module.exports = __webpack_public_path__ + "img/album07_13.119ebc05.jpg";